import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { trackEvent, V3Data, ClientConfigurationData } from "../Utility/Utility";
import logout from "../../../src/Assets/logout-profile-new.png";
import order from "../../../src/Assets/order-new.png";
import help from "../../../src/Assets/message-question.png";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import { onEnrolledSubmit } from "../../Store/Slices/validateLoginTokenSlice";
import { Modal } from "react-bootstrap";
import { set } from "react-hook-form";


// import myProfile from "../../../src/Assets/my-profile-icon.png";
// import edit from "../../../src/Assets/edit-icon.png";
const Dashboard = ({ activeTab }) => {
  const translation = getTranslationData();
  const validateLoginTokenData = useSelector(
    (state) => state.validateLoginTokenSliceReducer.data
  );

  const dispatch = useDispatch();
  const [errorFirst, setErrorFirst] = useState(translation?.firstName_required);
  const [errorLastName, setErrorLastName] = useState(translation?.lastName_required);
  const [errorMobile, setErrorMobile] = useState(translation?.mobile_number_required);
  const [errorEmailMessage, setEmailMessage] = useState(translation?.email_validation_message);
  const [errorEmailRequired, setErrorEmailRequired] = useState(translation?.email_required);
  const [disabled, setDisabled] = useState(true);
  const [formData, setFormData] = useState({
    name: validateLoginTokenData?.memberProfile?.firstName || "",
    lastName: validateLoginTokenData?.memberProfile?.lastName || "",
    email: validateLoginTokenData?.memberProfile?.emailId || "",
    phoneNumber: validateLoginTokenData?.memberProfile?.mobileNumber || "",
  });
  const [profileMenu, setProfileMenu] = useState([]);
  const clientConfig = ClientConfigurationData();
  const configClient = useSelector((state) => state.clientDataReducer?.title);
  const clientTitle = configClient?.trim().toLowerCase();

  const [showModal, setShowModal] = useState(false);
  const handleClose = () => {
    setShowModal(false);

    setFormData({
      name: validateLoginTokenData?.memberProfile?.firstName || "",
      lastName: validateLoginTokenData?.memberProfile?.lastName || "",
      email: validateLoginTokenData?.memberProfile?.emailId || "",
      phoneNumber: validateLoginTokenData?.memberProfile?.mobileNumber || "",
    });
  };
  const handleShow = () => {
    setShowModal(true);
  };

  const v3Data = V3Data();
  // const memberData = GetMemberData();
  // const generateToken = GenerateToken();
  useEffect(() => {
    trackEvent("page_browse", {

      page_title: "My Profile",
      page_url: window.location.href,

    });
  }, []);
  const getInitials = (firstName = "", lastName = "") => {
    const firstLetter = firstName?.charAt(0) || "";
    const lastLetter = lastName?.charAt(0) || "";
    return `${firstLetter}${lastLetter}`.toUpperCase();
  };
  const [errors, setErrors] = useState({});

  const handleChange = (e, fieldName) => {
    const value = e.target.value;
    let error = "";
    // Validate fields
    if (fieldName === "email") {

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value) {
        error = errorEmailRequired;
        // setErrorEmailRequired(errorEmailRequired);
        setDisabled(true);
      } else if (!emailRegex.test(value)) {
        error = errorEmailMessage;
        setDisabled(true);
        // setEmailMessage(errorEmailMessage);
        // setErrorEmail(error);
      } else {
        error = "";
      }
    } else if (fieldName === "name" && !value.trim()) {
      error = errorFirst;
      // setErrorFirst(errorFirst);
    } else if (fieldName === "lastName" && !value.trim()) {
      error = errorLastName;
      // setErrorLastName(errorLastName);
    } else if (fieldName === "phoneNumber" && !value.trim()) {
      error = errorMobile;
      // setErrorMobile(errorMobile);
    }

    // update form data
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));

    // update errors
    setErrors((prev) => ({
      ...prev,
      [fieldName]: error,
    }));

    setDisabled(false);
  };


  const handleSubmit = () => {
    // Validate all fields
    if (
      !formData.name.trim() ||
      !formData.lastName.trim() ||
      !formData.email.trim() ||
      !formData.phoneNumber.trim()
    ) {
      toast.error("All fields are mandatory");
      return;
    }

    // Check for email validation errors
    if (errors.email) {
      toast.error(errors.email);
      return;
    }

    const payload = {
      culture: 1,
      PartnerCode: validateLoginTokenData?.partnerDetails?.partnerCode,
      customerId: validateLoginTokenData?.memberIdentifier,
      memberTypeCode: 1001,
      membershipStage: 1,
      alternateIds: validateLoginTokenData?.alternateIds,
      memberProfile: {
        firstName: formData.name,
        lastName: formData.lastName,
        mobileNumber: formData.phoneNumber,
        emailId: formData.email,
        // dob: validateLoginTokenData?.memberProfile?.dob,
        title: 0,
        maritalStatus: 0,
        gender: 0,
        address: validateLoginTokenData?.memberProfile?.address,
      },
      communicationChannel: validateLoginTokenData?.communicationChannel,
      otherAttributes: validateLoginTokenData?.otherAttributes,
      otherListAttribute: validateLoginTokenData?.otherListAttribute,
    };
    dispatch(onEnrolledSubmit({ ...payload }));
    setShowModal(false);
  };

  useEffect(() => {
    let isMounted = true;

    const loadProfileMenuConfig = async () => {
      if (!clientTitle) return;
      try {
        const response = await fetch(
          `/customConfig/${clientTitle}/profileMenu.json`,
          { cache: "no-store" }
        );
        const data = await response.json();
        data.sort((a, b) => a.displayOrder - b.displayOrder);
        const MenuItem = Array.isArray(data) ? data : [];
        setProfileMenu(MenuItem);
      }
      catch { }
    };
    loadProfileMenuConfig();
  }, [clientTitle]);
  return (
    // <div
    //   className={` fade shadow rounded myprofilecontent ${activeTab === "dashboard" ? " active" : ""
    //     }`}
    //   id="v-pills-home"
    //   role="tabpanel"
    // >
    <>
      <div
        className={`pb-5 ${activeTab === "dashboard" ? " active" : ""
          }`}
        id="v-pills-home"
        role="tabpanel"
      >
        <ToastContainer />
        <div className="d-flex flex-column align-items-center justify-content-center profile-update-section">
          {/* Avatar */}
          <div
            className="rounded-circle profile"
            style={{
              width: "102px",
              height: "102px",
              fontSize: "36.69px",
              fontWeight: "700",
            }}
          >
            {getInitials(validateLoginTokenData?.memberProfile?.firstName, validateLoginTokenData?.memberProfile?.lastName)}
          </div>
          <h5 className="mt-3 mb-4 px-5 position-relative">{[validateLoginTokenData?.memberProfile?.firstName, validateLoginTokenData?.memberProfile?.lastName]?.filter(Boolean).join(" ")}
            {clientConfig?.allowUserProfileEdit &&
              <i className="ms-2 fa fa-pen" onClick={handleShow}></i>}
          </h5>

          <div className="profile_detail_section">
            <div className="mb-4 position-relative profile_deatil_box">
              <small className="pb-2 text_muted d-block text-uppercase fw-semibold">
                Email
              </small>
              <span className="fw-medium">{validateLoginTokenData?.memberProfile?.emailId}
                {(
                  clientConfig?.allowUserProfileEdit &&
                  validateLoginTokenData?.memberIdentifier !==
                  validateLoginTokenData?.memberProfile?.emailId
                ) && (
                    <i
                      className="ms-2 fa-solid fa-pen"
                      onClick={handleShow}
                    />
                  )}
              </span>
            </div>
            <div className="profile_deatil_box">
              <small className="pb-2 text_muted d-block text-uppercase fw-semibold">
                Contact
              </small>
              <span className="fw-medium">+91 {validateLoginTokenData?.memberProfile?.mobileNumber}
                {clientConfig?.allowUserProfileEdit &&
                  validateLoginTokenData?.memberIdentifier !== validateLoginTokenData?.memberProfile.mobileNumber &&
                  <i className="ms-2 fa-solid fa-pen" onClick={handleShow}></i>
                }
              </span>
            </div>
          </div>

          <div className="border rounded-4 shadow-sm bg-white profile_link">
            <Link className="w-100 text-start text-black pb-3 border-bottom d-flex align-items-center" to={"/orders"}>
              <img src={order} alt="myorder-icon" className="myorder_icon" style={{ width: "20px" }} />
              My Orders
            </Link>

            <Link className="w-100 text-start text-black py-3 border-bottom d-flex align-items-center" to={"/contact-us"}>
              <img src={help} alt="help icon" className="myorder_icon" style={{ width: "20px" }} />
              Help
            </Link>
            {profileMenu && <>
              {profileMenu.find((item) => item?.label?.toLowerCase() === "logout" && item?.visible)?.visible && (
                <Link className="w-100 text-start text-black pt-3  border-0 d-flex align-items-center" to={"/logout"} >
                  <img src={logout} alt="logout-icon" className="myorder_icon" style={{ width: "20px" }} />
                  Log out
                </Link>
              )}
            </>}
          </div>
        </div>
      </div>
      {showModal &&

        <div className="modal_Dashboard">
          <Modal
            show
            centered
            backdrop
            keyboard
            enforceFocus={false}
            className="edit-profile-modal"
            onHide={handleClose}
            aria-labelledby="exampleModalLabel"
            id="DashboardModal"
          >
            {/* Header */}
            <Modal.Header closeButton className="edit-profile-header">
              <Modal.Title className="mb-0">Edit Profile</Modal.Title>
            </Modal.Header>

            {/* Body */}
            <Modal.Body className="edit-profile-body">
              <div className="form-group">
                <label>FIRST NAME</label>
                <input
                  type="text"
                  placeholder={formData?.name}
                  value={formData?.name}
                  name="name"
                  onChange={(e) => handleChange(e, "name")}
                  required
                />
                {errors.name && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    {errors.name}
                  </span>
                )}
              </div>

              <div className="form-group">
                <label>LAST NAME</label>
                <input
                  type="text"
                  name="lastName"
                  placeholder={formData?.lastName}
                  value={formData?.lastName}
                  onChange={(e) => handleChange(e, "lastName")}
                  required
                />
                {errors.lastName && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    {errors.lastName}
                  </span>
                )}
              </div>
              {(
                validateLoginTokenData?.memberIdentifier !==
                validateLoginTokenData?.memberProfile?.emailId
              ) ? (

                <div className="form-group">
                  <label>EMAIL ID</label>
                  <input
                    type="email"
                    name="email"
                    placeholder={formData?.email}
                    value={formData?.email}
                    onChange={(e) => handleChange(e, "email")}
                    required
                  />
                  {errors.email && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.email}
                    </span>
                  )}
                </div>
              )
                :
                (
                  <div className="form-group">
                    <label>PHONE NUMBER</label>
                    <input
                      type="tel"
                      name="phoneNumber"
                      placeholder={formData?.phoneNumber}
                      value={formData?.phoneNumber}
                      onChange={(e) => handleChange(e, "phoneNumber")}
                      required
                    />
                  </div>
                )
              }


            </Modal.Body>

            {/* Footer */}
            <Modal.Footer className="edit-profile-footer">
              <button className="btn-cancel" onClick={handleClose}>
                Cancel
              </button>

              <button className="btn-save" onClick={handleSubmit} disabled={disabled}>
                Save Changes
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      }
    </>
  );
};

export default Dashboard;
